<template>
  <div class="row mx-0 bg-secondary-3 py-2 px-3 rounded align-items-center justify-content-around">
    <div class="col-12 col-md-4">
      <span class="d-block color-black font-weight-bold mb-1">
        {{ student.fullName }}
      </span>
      <span class="color-gray-6 font-weight-normal">
        <em>{{ student.studentSieId }}</em>
      </span>
    </div>
    <div class="col-12 col-md-2">
      <span class="label">
        Grado:
      </span>
      <span class="content">
        {{ student.grade | empty }}
      </span>
    </div>
    <div class="col-12 col-md-2">
      <span class="label">
        Edad:
      </span>
      <span class="content">
        {{ student.age | empty }}
      </span>
    </div>
    <div class="col-12 col-md-2">
      <span class="label">
        Estatus:
      </span>
      <span class="content">
        {{ student.status | empty }}
      </span>
    </div>
    <div v-if="!readonly" class="col-12 col-md-2 text-right">
      <action-button
        variant="outline-danger"
        text="Remover"
        i="far fa-times-circle"
        @click="$emit('remove', student.studentSieId)"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';

const empty = (value) =>
  value || '--';

export default {
  name: 'ParentStudentRow',
  filters: { empty },
  components: { ActionButton },
  props: {
    student: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  display: block;
}
</style>
